import { useTranslation } from 'react-i18next';
import type { CategoryDescriptor } from './categories';

// Resolves a category descriptor to its translated display name
export default function useCategoryLabel() {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Shared.Customers.PaymentMethodsTab.DataEnrichment.Insights',
  });

  return (descriptor: CategoryDescriptor): string =>
    t(`Categories.${descriptor.labelKey}`, { defaultValue: descriptor.defaultLabel });
}
